import { useFormContext } from 'react-hook-form';
import { PREFECTURES } from '@/constants/sharedJobPostConstants';
import type { FormValue } from '../searchSchema';

// 再レンダリングのたびに新しい配列を渡さないためモジュールレベルで保持する
const PREFECTURE_NAMES = PREFECTURES.map((prefecture) => prefecture.name);

// MultiSelectPopover は県名を扱うため、フォーム値の都道府県コードとの相互変換をここへ集約する（Issue #3401）
export default function usePrefectureSelect() {
  const { watch, setValue } = useFormContext<FormValue>();

  const prefectureNames = (watch('prefectureCodes') ?? [])
    .map((code) => PREFECTURES.find((prefecture) => prefecture.code === code)?.name)
    .filter((name): name is string => Boolean(name));

  const handlePrefectureUpdate = (names: string[]) => {
    const codes = names
      .map((name) => PREFECTURES.find((prefecture) => prefecture.name === name)?.code)
      .filter((code): code is number => code !== undefined);
    setValue('prefectureCodes', codes);
  };

  return { prefectureNames, prefectureOptions: PREFECTURE_NAMES, handlePrefectureUpdate };
}
